import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import { get, isEmpty } from 'lodash';

import queryString from 'query-string';
import template from 'url-template';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import BacnetInventoryTable from '../../components/InventoryTable/BacnetInventoryTable';
import BOBDate from '../../components/BOBDate';
import ConfirmationModal from '../Modals/ConfirmationModal';
import DeviceModificationModal from '../Modals/DeviceModificationModal';
import DeviceModificationResultModal from '../Modals/DeviceModificationResultModal';
import RefreshInventorySettingsModal from '../Modals/RefreshInventorySettingsModal';
import EsmsPage from '../../components/EsmsPage';
import ElapsedTime from '../../components/ElapsedTime';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import * as BasAgentActions from '../../actions/basAgentActions';
import * as DeviceActions from '../../actions/deviceActions';
import * as InventoryActions from '../../actions/inventoryActions';
import * as ProfileActions from '../../actions/profileActions';

const AgentsUrl = template.parse('/iothub/basagents{?company}');
const ExistingProfileUrl = template.parse('/iothub/profiles/bacnet/existing{?basAgent,company}');
const IotHubUrl = template.parse('/iothub{?company}');
const ManageAgentUrl = template.parse('/iothub/basagents/manage{?company,basAgent}');

class BacnetInventoryPage extends Component {
    state = {
        completedItems:            0,
        deviceCreationModalOpen:   false,
        disableUseExisting:        true,
        disableCreateDevices:      true,
        isSubmitting:              false,
        pendingItems:              0,
        resultErrors:              [],
        selectedDevices:           [],
        showRefreshInventoryModal: false,
    }

    async componentDidMount() {
        const {
            fetchBacnetInventory,
            fetchBasAgent,
            location,
            selectedAgent
        } = this.props;

        if (!isEmpty(selectedAgent)) {
            const basType = get(selectedAgent.driverConfiguration[0], 'basType', '').toLowerCase();

            if (isEmpty(basType)) {
                this.redirectToBasAgents();
                return;
            }

            await fetchBacnetInventory(selectedAgent);
        } else {
            const queryValues = queryString.parse(location.search);
            const basAgent = get(queryValues, 'basAgent', '');

            if (isEmpty(basAgent)) {
                this.redirectToBasAgents();
                return;
            }

            const agent = await fetchBasAgent(basAgent);

            if (isEmpty(agent)) {
                this.redirectToBasAgents();
                return;
            }

            await fetchBacnetInventory(agent);
        }
    }

    componentDidUpdate(prevProps) {
        const { fetchBacnetInventory, selectedAgent } = this.props;

        if (selectedAgent !== prevProps.selectedAgent) {
            const status = get(selectedAgent, 'status.actions.inventoryScan', '').toLowerCase();

            if (status === 'completed') {
                fetchBacnetInventory(selectedAgent);
            }
        }
    }

    redirectToBasAgents = () => {
        const { history, location } = this.props;
        const queryValues = queryString.parse(location.search);

        history.push(AgentsUrl.expand({
            company: queryValues.company
        }));
    }

    handleIotHubRoute = () => {
        const { history, location } = this.props;
        const queryValues = queryString.parse(location.search);

        history.push(IotHubUrl.expand({
            company: queryValues.company
        }));
    }

    handleExistingProfileRoute = () => {
        const { companyInfo, history, location } = this.props;
        const queryValues = queryString.parse(location.search);

        history.push(ExistingProfileUrl.expand({
            basAgent: queryValues.basAgent,
            company:  companyInfo.companyId
        }));
    }

    handleSelectedAgentRoute = () => {
        const { history, location, selectedAgent } = this.props;
        const queryValues = queryString.parse(location.search);

        history.push(ManageAgentUrl.expand({
            company:  queryValues.company,
            basAgent: selectedAgent.id
        }));
    }

    handleRefreshInventory = dateRange => {
        const { selectedAgent, triggerInventoryScan } = this.props;
        const agentId = get(selectedAgent, 'id', '');
        const configurationId = get(selectedAgent, 'driverConfiguration[0].id', '');

        if (agentId && configurationId) {
            triggerInventoryScan(agentId, configurationId, dateRange);
        }
    }

    handleToggleShowRefreshInventoryModal = () => {
        this.setState(state => ({
            showRefreshInventoryModal: !state.showRefreshInventoryModal
        }));
    }

    handleCreateDevicesObjects = async () => {
        const {
            createBulkDevice,
            selectedAgent
        } = this.props;

        const agentId = get(selectedAgent, 'id', '');
        const configId = get(selectedAgent, 'driverConfiguration[0].id');

        await createBulkDevice(agentId, configId);
    }

    handleToggleSelection = selectedDevices => {
        const { devicesToggle } = this.props;

        let disableCreateDevices = true;
        let disableUseExisting = true;
        let devicesWithProfiles = [];

        if (selectedDevices.length) {
            disableUseExisting = false;

            devicesWithProfiles = selectedDevices.filter(device => device.profileId);

            disableCreateDevices = devicesWithProfiles.length === 0;
        }

        if (selectedDevices.length) {
            devicesToggle(selectedDevices);
        }

        this.setState({
            disableCreateDevices,
            disableUseExisting,
            selectedDevices
        });
    }

    handleToggleDeviceCreationModal = state => {
        this.setState({
            deviceCreationModalOpen: state
        });
    }

    handleResultClose = () => {
        this.setState({
            completedItems: 0,
            resultErrors:   [],
            isSubmitting:   false,
            pendingItems:   0
        });
    }

    renderMessage = () => {
        const { bacnetInventory } = this.props;

        if (isEmpty(bacnetInventory)) return null;

        const { selectedDevices } = this.state;
        const deviceNames = selectedDevices.map(device => device.DeviceName);

        return (
            <React.Fragment>
                <p>The following Devices will be created:</p>
                <ul>
                    {deviceNames.map((name, index) => <li key={index}>{name}</li>)}
                </ul>
            </React.Fragment>
        );
    }

    render() {
        const {
            companyInfo,
            currentScopes,
            bacnetInventory,
            loading,
            selectedAgent,
            setDevice
        } = this.props;

        const {
            completedItems,
            disableUseExisting,
            disableCreateDevices,
            isSubmitting,
            pendingItems,
            resultErrors
        } = this.state;

        if (!selectedAgent) {
            return null;
        }

        const isFullHubAllowed = isAllowed(currentScopes, Permissions('iothubFull'));

        return (
            <EsmsPage
                parents={[companyInfo.companyName, 'BAS Agents', selectedAgent.name]}
                title="BAS Inventory"
                handlers={
                    [
                        this.handleIotHubRoute,
                        this.redirectToBasAgents,
                        this.handleSelectedAgentRoute,
                        this.handleExistingProfileRoute
                    ]
                }
                subtitle={(
                    <React.Fragment>
                        <BOBDate
                            date={get(this.props.selectedAgent, 'actions.inventoryScan.timeCompleted')}
                            render={date => `Latest Inventory Date: ${date}`}
                        />
                        <p />
                        <ElapsedTime
                            dateTime={this.props.updatedAt}
                            render={(time) => `Updated ${time}`}
                        />
                    </React.Fragment>
                )}
            >
                <ActionBar>
                    <ActionBarItem
                        onClick={this.handleExistingProfileRoute}
                        hidden={!isFullHubAllowed}
                        disabled={disableUseExisting}
                        type="profile"
                    >
                        Use Existing Profile
                    </ActionBarItem>
                    <ActionBarItem
                        onClick={process.env.bacnetPartialInventory ? this.handleToggleShowRefreshInventoryModal : this.handleRefreshInventory}
                        hidden={!isFullHubAllowed}
                        type="refresh"
                    >
                        Refresh Inventory
                    </ActionBarItem>
                    <ActionBarItem
                        onClick={() => this.handleToggleDeviceCreationModal(true)}
                        hidden={!isFullHubAllowed}
                        disabled={disableCreateDevices}
                        type="save"
                    >
                        Create Devices and Objects
                    </ActionBarItem>
                </ActionBar>
                <BacnetInventoryTable
                    companyInfo={companyInfo}
                    bacnetInventory={bacnetInventory}
                    isFullHubAllowed={isFullHubAllowed}
                    loading={loading}
                    onDeviceSelection={this.handleDeviceSelection}
                    onInventoryToggle={this.handleToggleSelection}
                    scopes={currentScopes}
                    setDevice={setDevice}
                />
                <ConfirmationModal
                    open={this.state.deviceCreationModalOpen}
                    close={() => this.handleToggleDeviceCreationModal(false)}
                    confirm={this.handleCreateDevicesObjects}
                    title="Create Devices and Objects"
                    message={this.renderMessage()}
                />
                <DeviceModificationModal
                    completed={completedItems}
                    modificationType="create"
                    open={isSubmitting}
                    pending={pendingItems}
                />
                <DeviceModificationResultModal
                    errors={resultErrors}
                    modificationType="create"
                    onClose={this.handleResultClose}
                    open={resultErrors.length > 0}
                />
                <RefreshInventorySettingsModal
                    onClose={this.handleToggleShowRefreshInventoryModal}
                    open={this.state.showRefreshInventoryModal}
                    handleRefreshInventory={this.handleRefreshInventory}
                    handleSelectedAgentRoute={this.handleSelectedAgentRoute}
                    title="Refresh Inventory Settings"
                />
            </EsmsPage>
        );
    }
}

const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents, selectedAgentId } = basAgent;
    const selectedAgent = basAgents[selectedAgentId];
    return {
        bacnetInventory: state.inventory.bacnetInventory,
        companyInfo:     state.companyInfo,
        currentScopes:   state.core.currentScopes,
        devices:         state.device.devices,
        loading:         state.inventory.loading,
        selectedAgent,
        selectedDevice:  state.device.selectedDevice,
        selectedDevices: state.device.selectedDevices,
        updatedAt:       state.inventory.updatedAt
    };
};

const mapDispatchToProps = {
    ...BasAgentActions,
    ...DeviceActions,
    ...InventoryActions,
    ...ProfileActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BacnetInventoryPage));
